import Add from '@material-ui/icons/Add'
import React from 'react'
import Fade from 'react-reveal/Fade'
import CalendarZoneDateForm from '../../components/CalendarZone/CalendarZoneDateForm/CalendarZoneDateForm'
import CalendarZoneForm from '../../components/CalendarZone/CalendarZoneForm/CalendarZoneForm'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Search from '../../components/UI/Search/Search'
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'

const CalendarZones = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [calendarZones, setCalendarZones] = React.useState([])
    const [newCalendarZonePage, setNewCalendarZonePage] = React.useState(false)
    const [showDates, setShowDates] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [calendarZone, setCalendarZone] = React.useState('')
    const [calendarZoneId, setCalendarZoneId] = React.useState('')
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "calendarZone": {
                "description": searchParams.description.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/calendarzones/getCalendarZones'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.calendarZones)
                    pushData(newList)
                    setCalendarZones(newList)
                    setPageCount(result.count)
                    setLoading(false);
                }
            })
            .catch(error => console.log(error))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'description',
                header: "نام",
                align: 'center',
            },
        ];
        const buttons = [];
        buttons.push({ id: 1, text: 'تخصیص تاریخ', clicked: assignDate });
        buttons.push({ id: 2, text: 'ویرایش', clicked: editCalendarZone });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                description: d.description,
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const toggleNewLockerForm = (event, value) => {
        if (value == false) {
            search();
        }
        setNewCalendarZonePage(value)
    }

    const assignDate = (id, data) => {
        setCalendarZoneId(id)
        setNewCalendarZonePage(false)
        setShowDates(true)
    }
    const toggleAssignDate = (event, value) => {
        setShowDates(value)
    }

    const addNewCalendarZone = (event, id) => {
        setCalendarZone('')
        setEdit(false)
        toggleNewLockerForm(event, true)
    }

    const editCalendarZone = (id, data) => {
        const lckrTp = data.filter(l => l.id == id)
        if (lckrTp != null && lckrTp.length != 0) {
            setCalendarZone(lckrTp[0])
            setEdit(true)
            toggleNewLockerForm(null, true)
        }
    }


    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>

    return (
        <div>
            {loading ? <Spinner /> : ''}
            {!newCalendarZonePage && !showDates ?
                <Fade duration={200} left cascade>
                    <div>
                        <Search class="orders-search" form={form} />
                        {permission != null && permission.includes('ZONE_WRITE') ?
                            <div className="row justify-content-center mt-3 ml-3">
                                <div className="UserGeneralBtn mb-2">
                                    <div onClick={(event) => addNewCalendarZone(event)} className="Add">
                                        <Add className="UserIcon" />
                                    </div>
                                </div>
                            </div>
                            : ''
                        }

                        {rerender ?
                            // <Spinner />
                            <Table hasDetails={false} data={calendarZones} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                            :
                            <Table hasDetails={false} data={calendarZones} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                        }
                    </div>
                </Fade>
                :
                <div>

                    {!showDates ?
                        <CalendarZoneForm edit={edit} calendarZone={edit ? calendarZone : ''} toggleNewLockerForm={toggleNewLockerForm} />
                        : ''}
                </div>
            }
            {showDates ?
                <CalendarZoneDateForm calendarZoneId={calendarZoneId} toggleAssignDate={(event) => toggleAssignDate(event, false)} />
                : ''}
        </div>
    )
}

export default CalendarZones